export default __webpack_public_path__ + "static/media/MRNS.3e2d40ae.png";